import React from 'react';

import { Link } from '../../components';
import { Tooltip } from 'react-tooltip';
import Rating from '../Rating';
import Tags from '../Tags';
import {
  CardContainer,
  Image,
  ChallengeDescription,
  ChallengeInfo,
  ChallengeName,
  ChallengeInfoHeader,
  SponsorImage,
  SelectedCheckbox,
  CompletionContainer,
} from './styles';

export default function ChallengeCard({
  name,
  description,
  image,
  contestLogo,
  averageRating,
  isCompletedByUser,
  sponsor,
  onClick,
  link,
  thumbnail,
  keywords = [],
  totalCompletions,
  type,
  isFreecode,
}) {
  return (
    <CardContainer hasImage={!!image || !!thumbnail} onClick={onClick}>
      <Link to={link}>
        {(!!image || !!thumbnail) && <Image image={!!thumbnail ? thumbnail : image} />}
        {sponsor && contestLogo && <SponsorImage data-tip="Sponsor" src={contestLogo} />}
        {isCompletedByUser && (
          <>
            <SelectedCheckbox>
              <i
                className="fa fa-check-square-o fa-2x"
                aria-hidden="true"
                data-tooltip-id={`completedTipFor${name}`}
                data-tooltip-content="Completed"
                data-tooltip-variant="info"
              ></i>
            </SelectedCheckbox>
            <Tooltip id={`completedTipFor${name}`} place="left" className="custom-tooltip" />
          </>
        )}
        <ChallengeInfo>
          <ChallengeInfoHeader>
            <ChallengeName>{name}</ChallengeName>
            {type !== 'courses' && <Rating readonly size={8} rating={averageRating} />}
          </ChallengeInfoHeader>
          <ChallengeDescription dangerouslySetInnerHTML={{ __html: description }} />
          {isFreecode && <Tooltip id={`freecode${name}`} place="top" className="custom-tooltip" />}
          <span
            data-tooltip-id={isFreecode && `freecode${name}`}
            data-tooltip-content="Freecodes do not have a correct solution"
            data-tooltip-variant="info"
          >
            <Tags tags={keywords} />
          </span>
          {totalCompletions ? <CompletionContainer>No. of completions: {totalCompletions}</CompletionContainer> : null}
        </ChallengeInfo>
      </Link>
    </CardContainer>
  );
}
